import { Grid, TextField, Collapse, IconButton } from '@mui/material'
import React from 'react'
import { useShowController, useTranslate } from 'react-admin'
import { ShowCard } from 'src/components/uiElements/cards/ShowCard'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useState } from 'react'


export const TaxInformation = () => {
    const translate = useTranslate()
    const {record} = useShowController()
    const [isExpanded, setIsExpanded] = useState(true)
    const labelStyle = { display: 'block', marginBottom: '2px' }

  return (
    <ShowCard
        title={translate('ra.field.fiscal_data')}
        posTitle={
            <IconButton
                size='small'
                onClick={()=>setIsExpanded(prev=>!prev)}
                style={{
                    transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.2s'
                }}
            >
                <ExpandMoreIcon />
            </IconButton>
        }
    >
        <Collapse in={isExpanded} unmountOnExit style={{width:'100%'}}>
            <Grid container spacing={2}>
                <Grid item sm={12} md={6} lg={6}>
                    <label htmlFor="name" style={labelStyle}>{translate('ra.field.business_name')}</label>
                    <TextField
                        id={'name'}
                        variant='standard'
                        size='small'
                        fullWidth
                        disabled
                        label={null}
                        style={{fontStyle:record.business_unit_relation?.fiscal_data_relation?.name ? 'inherit' :'italic'}}
                        value={record.business_unit_relation?.fiscal_data_relation?.name ?? translate('ra.message.pending_business_unit')}
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={3}>
                    <label htmlFor="document-type" style={labelStyle}>{translate('ra.entity.document-type')}</label>
                    <TextField
                        id={'document-type'}
                        variant='standard'
                        size='small'
                        fullWidth
                        disabled
                        label={null}
                        value={record.business_unit_relation?.fiscal_data_relation?.document_type_relation?.long_name}
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={3}>
                    <label htmlFor="document" style={labelStyle}>{translate('ra.field.document')}</label>
                    <TextField
                        id={'document'}
                        variant='standard'
                        size='small'
                        fullWidth
                        disabled
                        label={null}
                        value={record.business_unit_relation?.fiscal_data_relation?.document_number}
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={6}>
                    <label htmlFor="fiscal_address" style={labelStyle}>{translate('ra.field.fiscal_address')}</label>
                    <TextField
                        id={'fiscal_address'}
                        variant='standard'
                        size='small'
                        fullWidth
                        disabled
                        label={null}
                        value={record.business_unit_relation?.address}
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={6}>
                    <label htmlFor="email" style={labelStyle}>{translate('ra.field.email')}</label>
                    <TextField
                        id={'email'}
                        variant='standard'
                        size='small'
                        fullWidth
                        disabled
                        label={null}
                        value={record.business_unit_relation?.email}
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={6}>
                    <label htmlFor="fantasy_name" style={labelStyle}>{translate('ra.field.fantasy_name')}</label>
                    <TextField
                        id={'fantasy_name'}
                        variant='standard'
                        size='small'
                        fullWidth
                        disabled
                        label={null}
                        value={record.business_unit_relation?.fantasy_name}
                    />
                </Grid>
                <Grid item sm={12} md={6} lg={3}>
                    <label htmlFor="type_responsible" style={labelStyle}>{translate('ra.field.type_responsible')}</label>
                    <TextField
                        id={'type_responsible'}
                        variant='standard'
                        size='small'
                        fullWidth
                        disabled
                        label={null}
                        value={record.business_unit_relation?.fiscal_data_relation?.type_responsible_relation?.name}
                    />
                </Grid>

                <Grid item sm={12} md={6} lg={3} >
                    <label htmlFor="billing_code" style={labelStyle}>{translate('ra.field.billing_code')}</label>
                    <TextField
                        id={'billing_code'}
                        variant='standard'
                        size='small'
                        fullWidth
                        disabled
                        label={null}
                        value={record.business_unit_relation?.fiscal_data_relation?.tma_code}
                    />
                </Grid>
            </Grid>
        </Collapse>
    </ShowCard>
  )
}